import React from 'react';
import IconKeyValue from 'components/underwrite/shared/header/IconKeyValue';
import { withStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '24px',
    // Use flexFlow + overflow to hide any badges that would go past the parent container in smaller resolutions
    flexFlow: 'column',
    overflow: 'hidden'
  },
  vertDivider: {
    width: 1,
    height: '100%',
    margin: '0 7px 0 4px'
  },
});

const BadgeSection = ({ classes, selectedOpportunity }) => {
  const { beds, baths, sqft, yearBuilt, lotSize } = selectedOpportunity;
  return (
    <div className={classes.root}>
      {beds && <IconKeyValue name="beds" showInvalidText={beds > 10} value={beds} />}
      <Divider className={classes.vertDivider} />
      {baths && <IconKeyValue name="baths" showInvalidText={baths > 10} value={baths} />}
      <Divider className={classes.vertDivider} />
      {sqft && <IconKeyValue name="sqft" value={sqft.toLocaleString()} />}
      <Divider className={classes.vertDivider} />
      {yearBuilt && <IconKeyValue name="Year Built:" value={yearBuilt} reverse />}
      <Divider className={classes.vertDivider} />
      <IconKeyValue name="Lot Size:" value={lotSize ? lotSize.toLocaleString() : null} reverse />
    </div>
  );
};

export default withStyles(styles)(BadgeSection);
